export const OAUTH_STATE_COOKIE = 'speedmixr_oauth_state';
export const OAUTH_NEXT_COOKIE = 'speedmixr_oauth_next';

// Return only to room pages or the lobby; reject absolute and protocol-relative URLs.
export function safeNextPath(value: string | null | undefined): string {
  return value && /^\/r\/[a-z0-9-]+$/.test(value) && value.length <= 100 ? value : '/lobby';
}
